import React from "react";

export type SelectableCustomersFilterContextType = {
  onCustomerSelect: (customerId: string) => void;
  selectedCustomerIds: string[];
  onClearAllPress: () => void;
};

export const SelectableCustomersFilterContext = React.createContext<
  SelectableCustomersFilterContextType | undefined
>(undefined);
